import { render, staticRenderFns } from "./EmptyListImageRequests.vue?vue&type=template&id=45b2bf36&scoped=true"
var script = {}
import style0 from "./EmptyListImageRequests.vue?vue&type=style&index=0&id=45b2bf36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2bf36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b2bf36')) {
      api.createRecord('45b2bf36', component.options)
    } else {
      api.reload('45b2bf36', component.options)
    }
    module.hot.accept("./EmptyListImageRequests.vue?vue&type=template&id=45b2bf36&scoped=true", function () {
      api.rerender('45b2bf36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/emptyListImages/EmptyListImageRequests.vue"
export default component.exports